import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { ImportConfigurationClient, FilterDTO, SortDirection, FilterOperator, ImportConfigurationType } from "src/app/base/models/models.swagger.generated";
import { ToastService } from "src/app/base/services/toast.service";
import { IPagedItems } from "src/app/base/shared/syncfusion/paged-items.interface";
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { ErrorType } from 'src/app/core/routing/error-types';


@Injectable({
  providedIn: 'root'
})
export class ImportConfigurationTemplateService extends ShowInactiveService implements IAdaptorService {
  constructor(
    private importConfigurationClient: ImportConfigurationClient,
    private toastService: ToastService,
  ) {
    super();
  }
  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (!filters) {
      filters = [];
    }
    filters.push(new FilterDTO({ isComplex: false, field: 'type', operator: FilterOperator.Equal, value: ImportConfigurationType.Template.toString() }));
    filters.push(new FilterDTO({isComplex: false, field: 'isActive', operator: FilterOperator.Equal, value: 'true'}));

    return this.importConfigurationClient.searchImportConfigurations(undefined, skip, take, sortBy, sortDirection, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
